import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreLegacyModule } from '@isophi/core-legacy';
import { CoreUiModule } from '@isophi/core-ui';
import { TeachersSharedModule } from '@isophi/teachers-shared';
import { UiTemplateModule } from '@isophi/ui-template';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { NgxPrintModule } from 'ngx-print';
import { NgxSimpleTextEditorModule } from 'ngx-simple-text-editor';
import { NgxSpinnerModule } from 'ngx-spinner';

import { CheckboxInputComponent } from './components/checkbox-input/checkbox-input.component';
import { ChildDetailAlertInfoComponent } from './components/child-detail-alert-info/child-detail-alert-info.component';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { DateInputComponent } from './components/date-input/date-input.component';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';
import { DemoPopupComponent } from './components/demo-popup/demo-popup.component';
import { DictationButtonComponent } from './components/dictation-button/dictation-button.component';
import { ExcuseModalComponent } from './components/excuse-modal/excuse-modal.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { GroupAndChildrenFilterComponent } from './components/group-and-children-filter/group-and-children-filter.component';
import { GroupDetailCardComponent } from './components/group-detail-card/group-detail-card.component';
import { HomeHintComponent } from './components/home-hint/home-hint.component';
import { LicenseLockModalComponent } from './components/license-lock-modal/license-lock-modal.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ResetFilterComponent } from './components/reset-filter-component/reset-filter.component';
import { TextInputComponent } from './components/text-input/text-input.component';
import { ThematicBlockSelectComponent } from './components/thematic-block-select/thematic-block-select.component';
import { TransferChildrenModalComponent } from './components/transfer-children-modal/transfer-children-modal.component';
import { TransferWorkplaceModalComponent } from './components/transfer-workplace-modal/transfer-workplace-modal.component';
import { TINYMCE_SCRIPT } from './constants/rich-text-editor';
import { TranslateAbsenceReasonPipe } from './pipes/absence.pipe';
import { FormatUserRolePipe } from './pipes/format-user-role.pipe';
import { RichTextPipe } from './pipes/rich-text.pipe';
import { JoinStringPipe } from './pipes/string-join.pipe';
import { TagColorsPipe } from './pipes/tag-colors.pipe';
import { TransformEnumToReadableStringPipe } from './pipes/transform-enum-to-readable-string.pipe';

const SHARED_COMPONENTS = [
  ThematicBlockSelectComponent,
  DictationButtonComponent,
  ChildDetailAlertInfoComponent,
  CheckboxInputComponent,
  ContextMenuComponent,
  TextInputComponent,
  GroupDetailCardComponent,
  ExcuseModalComponent,
  NotFoundComponent,
  DateInputComponent,
  DateRangeFilterComponent,
  GroupAndChildrenFilterComponent,
  ResetFilterComponent,
  HomeHintComponent,
  DemoPopupComponent,
  FileUploadComponent,
  PaginationComponent,
  LicenseLockModalComponent,
  TransferChildrenModalComponent,
  TransferWorkplaceModalComponent,
];
const SHARED_PIPES = [
  JoinStringPipe,
  TransformEnumToReadableStringPipe,
  TranslateAbsenceReasonPipe,
  FormatUserRolePipe,
  TagColorsPipe,
  RichTextPipe,
];

@NgModule({
  imports: [
    CommonModule,
    CoreLegacyModule,
    CoreUiModule,
    NgxSpinnerModule,
    RouterModule,
    UiTemplateModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    TeachersSharedModule,
    ReactiveFormsModule,
    NgxPrintModule,
    NgxSimpleTextEditorModule,
    EditorModule,
  ],
  declarations: [...SHARED_COMPONENTS, ...SHARED_PIPES],
  exports: [
    ...SHARED_COMPONENTS,
    ...SHARED_PIPES,
    CoreUiModule,
    NgxSpinnerModule,
    RouterModule,
    UiTemplateModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    TeachersSharedModule,
    ReactiveFormsModule,
    NgxSimpleTextEditorModule,
    EditorModule,
  ],
  // TinyMCE is self-hosted from /tinymce (see shared/constants/rich-text-editor.ts)
  providers: [SHARED_PIPES, { provide: TINYMCE_SCRIPT_SRC, useValue: TINYMCE_SCRIPT }],
})
export class SharedModule {
  public static forRoot() {
    return {
      ngModule: SharedModule,
    };
  }
}
